export default __webpack_public_path__ + "static/media/photo--lg--22.0df4e4c6.jpg";